const HELP_CATEGORIES = [
  {
    id: "getting-started",
    icon: "fas fa-rocket",
    color: "#667eea",
  },
  {
    id: "campaigns",
    icon: "fas fa-bullhorn",
    color: "#e74c3c",
  },
  {
    id: "fast-eval",
    icon: "fas fa-bolt",
    color: "#f39c12",
  },
  {
    id: "park-management",
    icon: "fas fa-map-marked-alt",
    color: "#1abc9c",
  },
  {
    id: "sectors",
    icon: "fas fa-file-alt",
    color: "#2ecc71",
  },
  {
    id: "animals",
    icon: "fas fa-paw",
    color: "#9b59b6",
  },
  {
    id: "enrichments",
    icon: "fas fa-gift",
    color: "#e67e22",
  },
  {
    id: "analysis",
    icon: "fas fa-chart-line",
    color: "#3498db",
  },
  {
    id: "tasks",
    icon: "fas fa-tasks",
    color: "#6f42c1",
  },
  {
    id: "health",
    icon: "fas fa-heartbeat",
    color: "#e74a3b",
  },
  {
    id: "admin",
    icon: "fas fa-cog",
    color: "#95a5a6",
  },
];

export default HELP_CATEGORIES;
